import {
  On3IconQuotationMark,
  On3IconSportsQuotes,
  On3IconTwitterGrey,
} from '@on3/icons';
import { Pagination } from 'components/UI/Pagination/Pagination';
import { Text } from 'components/UI/Typography/Text';
import Link from 'next/link';
import { useRouter } from 'next/router';
import { type ICoachQuotesPageProps } from 'pages/db/coach/[id]/quotes';
import { useCallback, useState } from 'react';

import { CompactHeader } from '../Header/CompactHeader';
import styles from './CoachQuotes.module.scss';

export const CoachQuotes = ({
  coachQuotes,
  coachInfo,
}: ICoachQuotesPageProps) => {
  const { list, pagination } = coachQuotes;

  const { count = 0, currentPage = 1, limit = 25 } = pagination || {};
  const [pageNumber, setPageNumber] = useState(currentPage);
  const router = useRouter();

  const showPagination = count > limit;

  const handleChange = useCallback(
    (event: React.ChangeEvent<unknown>, value: number) => {
      setPageNumber(value);
      router.push({
        pathname: router.pathname,
        query: { ...router.query, page: value },
      });
    },
    [router],
  );

  return (
    <section>
      <CompactHeader coachInfo={coachInfo} />
      <div className={styles.iconWrapper}>
        <On3IconSportsQuotes height={16} width={152} />
        <div className={styles.twitterWrapper}>
          <On3IconTwitterGrey height={10} width={16} />
          <Link
            className={styles.twitterText}
            href="https://twitter.com/SportsQuotesOn3"
            rel="noopener noreferrer"
            target="_blank"
          >
            <Text color="primary" variant="caption">
              @sportsquoteson3
            </Text>
          </Link>
        </div>
      </div>
      {showPagination && (
        <Pagination
          count={pagination?.pageCount}
          onChange={handleChange}
          page={pageNumber}
        />
      )}
      <ul>
        {!!list?.length &&
          list?.map((quote) => (
            <li className={styles.quotesWrapper} key={quote?.key}>
              <On3IconQuotationMark height={47} />
              <Text className={styles.quotes}>{quote.body}</Text>
            </li>
          ))}
        {!list?.length && (
          <Text className={styles.noListText} component="li">
            There are no quotes available.
          </Text>
        )}
      </ul>
      {showPagination && (
        <Pagination
          count={pagination?.pageCount}
          onChange={handleChange}
          page={pageNumber}
        />
      )}
    </section>
  );
};
